import { double, triple } from './utilities';

type SizeKey = 'small' | 'medium' | 'large';

export type Size = {
  height: number;
  width: number;
};

const Sizes: Record<SizeKey, Size> = {
  small: { height: 160, width: 262 },
  medium: { height: 320, width: 524 },
  large: { height: 640, width: 1048 }
};

export type SizeWithScale = Size & { scale: string };

export const SizeList: Record<SizeKey, SizeWithScale[]> = {
  small: [
    // small mobile image
    { ...Sizes.small, scale: '1x' },
    { ...double(Sizes.small), scale: '2x' },
    { ...triple(Sizes.small), scale: '3x' }
  ],
  medium: [
    // tablet image
    { ...Sizes.medium, scale: '1x' },
    { ...double(Sizes.medium), scale: '2x' },
    { ...triple(Sizes.medium), scale: '3x' }
  ],
  large: [
    // desktop image
    { ...Sizes.large, scale: '1x' },
    { ...double(Sizes.large), scale: '2x' },
    { ...triple(Sizes.large), scale: '3x' }
  ]
};
